export default __webpack_public_path__ + "static/media/2.ec38ff06.png";